import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const { 
  pacienteList, 
  pacienteRead, 
  pacienteFichaMedicaRead, 
  pacienteTotalOrganizacion,
  pacienteCreateServicio,
  pacienteListServicio
} = actions;

const pacienteListAction = (paramBusqueda = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/pacientes/list.php?paramBusqueda=' + paramBusqueda);
      if (response.status === 200 && response.data.data) {
        let registrosList = [];
        registrosList = response.data.data.map(el => {
          return { value: el.id, label: el.nombre + ' - ' + el.municipio };
        });
        // dispatch(pacienteListSelectBox(registrosList));        
        dispatch(pacienteTotalOrganizacion(response.data.total_pacientes_organizacion));
        dispatch(pacienteList(response.data.data));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const pacienteCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/pacientes/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const pacienteReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/pacientes/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          if(response.data.data?.fecha_nacimiento){
             if(response.data.data.fecha_nacimiento == '0000-00-00'){
                response.data.data.fecha_nacimiento = '';
             }else{
                let arrayFecha = response.data.data.fecha_nacimiento.split('-');
                response.data.data.fecha_nacimiento = arrayFecha[2] + '-' +  arrayFecha[1] + '-' +  arrayFecha[0];
             }
         }
          dispatch(pacienteRead(response.data.data));
          return true;
        }
      } else {
        dispatch(pacienteRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const pacienteFichaMedicaCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/pacientes/fichaMedica.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const pacienteFichaMedicaReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/pacientes/fichaMedica.php?pacienteId=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(pacienteFichaMedicaRead(response.data.data));
          return true;
        }
      } else {
        dispatch(pacienteFichaMedicaRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const pacienteHistorialListAction = (pacienteId = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/pacientes/historialClinico.php?pacienteId=' + pacienteId);
      if (response.status === 200 && response.data.data) {
        dispatch(pacienteList(response.data.data));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const pacienteHistorialCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/pacientes/historialClinico.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const pacienteDeleteAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.delete('/pacientes/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const pacienteServicioCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/pacientes/servicio.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const pacienteServicioListAction = (pacienteId, tipoTransaccionId) => {
  return async dispatch => {
    try {
      const response = await DataService.get('/pacientes/servicio.php?pacienteId=' + pacienteId + '&tipoTransaccionId='+tipoTransaccionId);
      if (response.status === 200 && response.data.data) {
        dispatch(pacienteListServicio(response.data.data));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const pacientePagoCompraAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/pacientes/pago.php', data);
      if (response.status === 200) return response.data.data;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

export {
  pacienteListAction,
  pacienteCreateAction,
  pacienteReadAction,
  pacienteFichaMedicaCreateAction,
  pacienteFichaMedicaReadAction,
  pacienteHistorialListAction,
  pacienteHistorialCreateAction,
  pacienteDeleteAction,
  pacienteServicioCreateAction,
  pacienteServicioListAction,
  pacientePagoCompraAction
};
